import { useDispatch } from 'react-redux';
import { setBillboard } from './billboard.slice';
import { useEffect } from 'react';

export default function useBillboardId(id) {
  const dispatch = useDispatch();

  useEffect(() => {
    if (id) {
      dispatch(setBillboard(id));
    }
  }, [id, dispatch]);

  return null;
}
